import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatDate(timestamp: number) {
  const date = new Date(timestamp)

  const formattedDate = date.toLocaleDateString('en-GB', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })

  const formattedTime = date.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  })

  const day = date.getDate()
  const dateWithOrdinal = formattedDate.replace(/\d+/, `${day}`)

  // Combine date and time
  return { date: dateWithOrdinal, time: formattedTime }
}

export function computeNonPendingOrdersCount(data: { orders?: any[]; subscriptions?: any[] }): number {
  const orders = data.orders || []
  const subscriptions = data.subscriptions || []

  const nonPendingOrders = orders.filter((order: any) => order.status !== 'pending').length
  const nonPendingSubs = subscriptions.filter((sub: any) => sub.status !== 'pending').length

  return nonPendingOrders + nonPendingSubs
}

/**
 * Checks if a payment provider is Stripe (handles 'stripe', 'stripe_cc', etc.)
 */
export function isStripeProvider(paymentProvider?: string | null): boolean {
  return paymentProvider?.startsWith('stripe') ?? false
}

/**
 * Checks if a payment provider is Ryft (handles 'ryft', 'ryft_cc', etc.)
 */
export function isRyftProvider(paymentProvider?: string | null): boolean {
  return paymentProvider?.startsWith('ryft') ?? false
}
